import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';

import { v4 as uuid } from 'uuid';

const state = {
  avatar: null,
};

const mutations = {
  set_avatar(state, data) {
    state.avatar = data;
  },
};

const actions = {
  get_avatar: async ({ commit }, payload) => {
    try {
      const { url, version } = await (
        await firebase.firestore().collection('avatars').doc(payload).get()
      ).data();

      commit('set_avatar', `${url}&version=${version}`);
    } catch (error) {
      commit('set_avatar', null);
    }
  },
  upload_avatar: async ({ commit, rootGetters }, file) => {
    try {
      const bucketName = process.env.VUE_APP_STORAGE_BUCKET;
      const bucketPath = rootGetters['auth/get_user'].user_id;
      const storageRef = firebase.storage().ref();
      const avatarRef = storageRef.child(`avatar/${bucketPath}/avatar.png`);
      const version = uuid();
      const avatarUrl = `https://firebasestorage.googleapis.com/v0/b/${bucketName}/o/avatar%2F${bucketPath}%2Favatar.png?alt=media`;

      await avatarRef.put(file);

      await firebase.firestore().collection('avatars').doc(bucketPath).set({
        url: avatarUrl,
        version: version,
        created: new Date(),
      });

      commit('set_avatar', `${avatarUrl}&version=${version}`);
    } catch (error) {
      commit('set_avatar', null);
    }
  },
  get_avatar_by_user: async ({ commit }, payload) => {
    try {
      const { url, version } = await (
        await firebase.firestore().collection('avatars').doc(payload).get()
      ).data();
      return `${url}&version=${version}`;
    } catch (error) {
      commit('set_avatar', null);
    }
  },
};

const getters = {
  get_avatar(state) {
    return state.avatar;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
